module.exports = __webpack_public_path__ + "img/fix.1ba277e7.png";